import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config.js';

export default {
  data() {
    return {
      twConfig: resolveConfig(tailwindConfig),
    };
  },

  computed: {
    twColors() {
      return this.twConfig.theme.colors;
    },
  },
};
